import pkg from '../../../ngx-aur-mat-table/package.json';

/** Версия библиотеки, из которой собрана витрина (build-time, без рантайм-запросов). */
export const LIB_VERSION: string = pkg.version;

/** Мажор Angular, под который собрана библиотека (первая цифра версии — конвенция репо). */
export const ANGULAR_MAJOR: string = LIB_VERSION.split('.')[0];

export const NPM_URL = 'https://www.npmjs.com/package/ngx-aur-mat-table';
export const GITHUB_URL = 'https://github.com/NikolayNN/ngx-aur-mat-table';
export const RELEASES_URL = 'https://github.com/NikolayNN/ngx-aur-mat-table/releases';

/** Команда установки, показываемая в hero. */
export const INSTALL_CMD = 'npm install ngx-aur-mat-table';
